'use client';

import { Slot } from 'radix-ui';
import type { ReactNode } from 'react';
import { cn } from '../lib/utils';

export function Container({
  children,
  className,
  fluid = false,
  asChild = false,
}: {
  children: ReactNode;
  className?: string;
  fluid?: boolean;
  asChild?: boolean;
}) {
  const Comp = asChild ? Slot.Root : 'div';
  return (
    <Comp
      className={cn(
        'mx-auto px-[var(--container-padding)] 2xl:px-0',
        !fluid && 'max-w-[var(--layout-page-width)]',
        className
      )}
    >
      {children}
    </Comp>
  );
}
